module.exports = __webpack_public_path__ + "static/img/head_title.00e06fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/head_title.png
// module id = rReh
// module chunks = 1